module.exports = __webpack_public_path__ + "media/winter_2023_sweepstakes/scholarship-success-confirmation-lock-up-ce56ac82.png";